module.exports = __webpack_public_path__ + "img/form-img2.6c98abf4.png";